import apiRoutes from './api.routes';
import ModelService from './model.service';

const MetaDataService = new ModelService(apiRoutes.metaData, '/meta-data', 'content');

export default MetaDataService;



// WEBPACK FOOTER //
// ./src/services/metaData.service.js